<template>
  <div class="energy-center-box">
    <div class="top">
      <!-- <dummynotice/> -->
    </div>
    <!-- <target></target> -->
    <smartMap/>
    <div class="bottom">
        <!-- <Com_center_bottom2></Com_center_bottom2> -->
    </div>
  </div>
</template>

<script>
import target from "@/views/components/energyStorage/target.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
import smartMap from '@/views/components/smartMap_2'
import Com_center_bottom2 from "@/views/components/photovoltaic/Com_center_bottom2.vue";
import dummynotice from '@/views/components/photovoltaic/titlenum.vue'
export default {
  components: {
    target,
    smartMap,
    Com_center_bottom2,
    dummynotice
  },
  data() {
    return {
      showindex: 1,
      config: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 50,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 4, //表格行数
        header: [
          "序号",
          "簇号",
          "SOC",
          "SOH",
          "累计充电量",
          "累计放电量",
          "运行状态",
        ],
        data: [],
      },
      infoObj: {},
      pcsinfoObj: {},
      arrObj: {},
      pcsObj:{}
    };
  },
  mounted() {
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
@import "@/views/components/energyStorage/comm.scss";
.energy-center-box {
  width: 100%;
  height: 1620px;
  // margin-top: 100px;
  position: relative;
  .top{
    width: 100%;
    // background: red;
    position: absolute;
    top: 200px;
    z-index: 20;
    pointer-events: none; 
  }
  .bottom{
    width: 100%;
    // background: red;
    position: absolute;
    bottom: 350px;
    z-index: 20;
  }

}
</style>